export default __webpack_public_path__ + "img/Poppins-Thin_b4aee0e.ttf";